import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { Article } from '../../../interface';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueuePromoCount } from '../../../store/emarsys/action';
import { dateFormatterEmarsys } from '../../../helpers/utils/dateFormatter';

interface Props {
  firstRef: React.RefObject<HTMLElement>;
  pageTitle: string;
  pageName: string;
  breadcrumbItems: IBreadcrumbs[];
  sectionName: string;
  newParams?: Record<string, string | number | boolean>;
}

const useImpressionListPromo = ({
  firstRef,
  pageTitle,
  pageName,
  breadcrumbItems,
  sectionName,
  newParams,
}: Props) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue('EMARSYS');
      const isFlagPromoListActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO_LIST);
      if (isAuth && isFlagActive && isFlagPromoListActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: pageName ?? '',
          page_title: pageTitle ?? '',
          page_url: window.location.href,
          section_name: sectionName ?? '',
          menu_cat_lvl1: breadcrumbItems?.[1]?.name?.toLowerCase() || '',
          ...newParams,
        };

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueuePromoCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionListPromo;
